import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
interface PreviewWidthFrameProps {
  readonly maxWidthClass: string;
  readonly minWidthClass?: string;
  readonly contentClassName?: string;
  readonly disablePointerEvents?: boolean;
  readonly children: ReactNode;
}
export function PreviewWidthFrame(t0) {
  const $ = _c(12);
  const {
    maxWidthClass,
    minWidthClass,
    contentClassName,
    disablePointerEvents: t1,
    children
  } = t0;
  const disablePointerEvents = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== maxWidthClass || $[1] !== minWidthClass) {
    t2 = ["tw-w-full", maxWidthClass, minWidthClass].filter(Boolean);
    $[0] = maxWidthClass;
    $[1] = minWidthClass;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const frameClassName = t2.join(" ");
  const t3 = disablePointerEvents ? "tw-pointer-events-none" : "";
  let t4;
  if ($[3] !== contentClassName || $[4] !== t3) {
    t4 = [t3, contentClassName].filter(Boolean);
    $[3] = contentClassName;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const contentClasses = t4.join(" ");
  let t5;
  if ($[6] !== children || $[7] !== contentClasses) {
    t5 = <div className={contentClasses}>{children}</div>;
    $[6] = children;
    $[7] = contentClasses;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== frameClassName || $[10] !== t5) {
    t6 = <div className="tw-flex tw-w-full tw-justify-center"><div className={frameClassName}>{t5}</div></div>;
    $[9] = frameClassName;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}